import { Route as rootRoute } from './routes/__root';
import { Route as IndexRoute } from './routes/index';
import { Route as DashboardRoute } from './routes/dashboard';
import { Route as ProfileRoute } from './routes/profile';
import { Route as ClientsIndexRoute } from './routes/clients/index';
import { Route as ClientDetailRoute } from './routes/clients/$clientID';
import { Route as EncodersLayoutRoute } from './routes/encoders/_layout';
import { Route as EncodersIndexRoute } from './routes/encoders/index';
import { Route as EncoderDetailRoute } from './routes/encoders/$encoderID';
import { Route as EncoderTriageRoute } from './routes/encoders/triage';
import { Route as PersistentStreamsRoute } from './routes/persistent-streams';
import { Route as LiveStreamsIndexRoute } from './routes/events/live-streams/index';
import { Route as LiveStreamDetailRoute } from './routes/events/live-streams/$streamId';
import { Route as UpcomingStreamsIndexRoute } from './routes/events/upcoming-streams/index';
import { Route as UpcomingStreamDetailRoute } from './routes/events/upcoming-streams/$streamId';
import { Route as ReportsIndexRoute } from './routes/events/reports/index';
import { Route as SimulcastReportsRoute } from './routes/events/reports/simulcast';
import { Route as TrendsIndexRoute } from './routes/events/trends/index';
import { Route as SwapUserClientRoute } from './routes/utilities/swap-user-client';
import { Route as RunbookIndexRoute } from './routes/runbook/index';
import { Route as RunbookPageRoute } from './routes/runbook/$page';
import { Route as TranscodeJobsIndexRoute } from './routes/transcode-jobs/index';
import { Route as PipelineLogsRoute } from './routes/pipeline-logs/index';
import { Route as CaptioningReportsRoute } from './routes/captioning/reports';
import { Route as LegislativeSessionsRoute } from './routes/key-dates/legislative-sessions';
import { Route as MediaProbeRoute } from './routes/utilities/media-probe';
import { Route as VttAnalyzerRoute } from './routes/utilities/vtt-analyzer';
import { Route as UpdateEventStatusRoute } from './routes/utilities/update-event-status';
import { Route as ExportVttRoute } from './routes/utilities/export-vtt';
import { Route as OTTManagerRoute } from './routes/ott-manager/index';
import { Route as OTTManagerDetailRoute } from './routes/ott-manager/$apIdx';
import { Route as AwsRdsHealthRoute } from './routes/aws/rds-health';
import { Route as AwsRdsDetailRoute } from './routes/aws/rds/$instanceId';
import { Route as AwsEc2HealthRoute } from './routes/aws/ec2-health';
import { Route as AwsEc2DetailRoute } from './routes/aws/ec2/$instanceId';
import { Route as CaptionJobsRoute } from './routes/monitoring/caption-jobs';
import { Route as WebhookLogsRoute } from './routes/monitoring/webhook-logs';
import { Route as EventDetailRoute } from './routes/events/$eventId';


export const routeTree = rootRoute.addChildren([
  IndexRoute,
  DashboardRoute,
  ProfileRoute,
  ClientsIndexRoute,
  ClientDetailRoute,
  EncodersLayoutRoute.addChildren([
    EncodersIndexRoute,
    EncoderDetailRoute,
    EncoderTriageRoute,
  ]),
  PersistentStreamsRoute,
  LiveStreamsIndexRoute,
  LiveStreamDetailRoute,
  UpcomingStreamsIndexRoute,
  UpcomingStreamDetailRoute,
  ReportsIndexRoute,
  SimulcastReportsRoute,
  TrendsIndexRoute,
  SwapUserClientRoute,
  RunbookIndexRoute,
  RunbookPageRoute,
  TranscodeJobsIndexRoute,
  PipelineLogsRoute,
  CaptioningReportsRoute,
  LegislativeSessionsRoute,
  MediaProbeRoute,
  VttAnalyzerRoute,
  UpdateEventStatusRoute,
  ExportVttRoute,
  OTTManagerRoute,
  OTTManagerDetailRoute,
  AwsRdsHealthRoute,
  AwsRdsDetailRoute,
  AwsEc2HealthRoute,
  AwsEc2DetailRoute,
  CaptionJobsRoute,
  WebhookLogsRoute,
  EventDetailRoute,
]);
